<template>
    <div class="container">
        <van-nav-bar title="卡片管理" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
            <template #right>
                <van-icon name="search" size="18" />
            </template>
        </van-nav-bar>
        <van-list v-model="loading" :finished="finished" :finished-text="projectList.length > 0 ? '没有更多了' : '暂无数据'"
            @load="onLoad">
            <div class="list-box">
                <div class="list-item " @click="changePage(item)" :key="index" v-for="(item, index) in projectList">
                    <div class="list clearfix">
                        <div class="fl_left">
                            <div class="textAlign">活动商户：{{ item.tenantName }}</div>
                            <div class="textAlign">卡片序号：{{ item.cardNo ? item.cardNo : "未绑卡" }}</div>
                            <div class="textAlign">用户手机：{{ item.mobile }}</div>
                        </div>
                        <div class="fl_right">
                            <div class="amount">
                                <div class="textAlign">账户余额：{{ (item.totalAmount / 100).toFixed(2) }}</div>
                                <div class="textAlign">充值余额：{{ (item.payAmount / 100).toFixed(2) }}</div>
                                <div class="textAlign">赠送余额：{{ (item.givingAmount / 100).toFixed(2) }}</div>
                            </div>
                            <div>
                                <img src="../../assets/img/sel_right.png" alt="">
                            </div>
                        </div>
                    </div>

                    <div v-if="item.totalAmount > 0" class="clear" @click.stop="onClear(item.mobile, item.tenantId)">清零
                    </div>
                </div>
            </div>
        </van-list>

    </div>
</template>
  
<script>
import axios from '@/axios.js';
import { NavBar, Icon, Image, Toast, Loading, Picker, Field, Popup, List, } from 'vant';
export default {
    data() {
        return {
            allCount: 0,
            pageIndex: 1,
            pageSize: 10,
            loading: false,
            finished: false,
            projectList: [],

            keyword: "",
            startTime: "",
            endTime: "",
        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [List.name]: List
    },
    methods: {
        changePage(item) {
            this.$router.push({ path: "cardManageDetail.html", query: { id: item.cardId, tenantId: item.tenantId } })
        },
        onLoad() {
            // 异步更新数据
            setTimeout(() => {
                this.pageIndex++;
                this.getMoreList();
            }, 500)
        },
        hasLetter(str) {
            var result = str.match(/^.*[A-Za-z]+.*$/);
            if (result == null) return false;
            return true;
        },
        getProjectList() {
            this.loading = true;
            let cardNo = "", mobile = "";
            if (this.keyword) {
                if (this.hasLetter(this.keyword)) {
                    cardNo = this.keyword;
                } else {
                    mobile = this.keyword;
                }
            }
            axios.post("/card/pagelistv2", {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                filter: {
                    mobile: mobile,
                    cardNo: cardNo,
                    startTime: this.startTime,
                    endTime: this.endTime,
                }
            }).then((res) => {
                // 加载状态结束
                this.loading = false;
                this.projectList = res.data.pages.list;
                this.allCount = res.data.pages.total;
                this.statistics = res.data.statistics;
            }).catch(() => {
                this.loading = false;
            })
        },
        getMoreList() {
            let cardNo = "", mobile = "";
            if (this.keyword) {
                if (this.hasLetter(this.keyword)) {
                    cardNo = this.keyword;
                } else {
                    mobile = this.keyword;
                }
            }
            axios.post("/card/pagelistv2", {
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                filter: {
                    mobile: mobile,
                    cardNo: cardNo,
                    startTime: this.startTime,
                    endTime: this.endTime,
                }
            }).then((res) => {
                this.projectList = this.projectList.concat(res.data.pages.list);
                this.allCount = res.data.pages.total;
                // 加载状态结束
                this.loading = false;
                // 数据全部加载完成
                if (this.pageIndex * this.pageSize >= this.allCount) {
                    this.finished = true;
                }
            }).catch((err) => {
                this.loading = false;

                if (!err.isSuccess) {
                    this.finished = true;
                }
            })
        },
        onClickLeft() {
            this.$router.replace({ path: "home.html" });
        },
        onClickRight() {
            this.$router.push({ path: "search.html", query: { pageType: 7 } });
        },
        onClear(mobile, tenantId) {
            Toast.loading({
                duration: 0,       // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: 'spinner',
                message: '清零中...'
            });
            axios.get('/utils/setcardamounttozerotenant?mobile=' + mobile + '&tenantId=' + tenantId, {})
                .then((res) => {
                    if (res.isSuccess) {
                        this.pageIndex = 1;
                        this.getProjectList();
                    }
                }).finally(() => {
                    Toast.clear();
                })

        },
    },
    computed: {
    },
    created() {
        this.keyword = this.$route.query.keyword;
        this.startTime = this.$route.query.startTime;
        this.endTime = this.$route.query.endTime;
        this.getProjectList();
    },
    mounted() { },
    destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #F0F4F7
}

.container {
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    background: #F0F4F7;
}

.list-box {
    width: 100%;
    color: #373737;

    .list-item {
        background: #fff;
        position: relative;
        margin: 12px 0;
        padding: 12px 12px 36px 12px;

        .clear {
            color: #0000EE;
            border: 1px solid #0000EE;
            border-radius: 10px;
            padding: 0 5px;
            margin: 10px;
            width: 50px;
            text-align: center;
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }

    .list {
        font-size: 14px;
        width: 100%;
        background: #fff;



        display: flex;
        justify-content: space-between;

        .fl_right {
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .amount {
                width: 75%;
            }

            img {
                width: 6px;
                margin-left: 8px;
                margin-bottom: 2px;
                vertical-align: middle;
            }
        }

    }

    .textAlign {
        text-align: left;
    }

    .mg10 {
        margin-bottom: 10px;
    }

    .bold {
        font-weight: bold;
    }
}
</style>
  